var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPawSecondary = function SvgPawSecondary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FFF3E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5227 29.6434C26.6765 29.6434 18.4467 38.6812 18.4467 44.3897C18.3819 46.9604 20.3515 48.4998 23.669 48.4998C27.2635 48.4998 29.6427 46.651 32.5227 46.651C35.4322 46.651 37.8187 48.4998 41.3763 48.4998C44.6246 48.4998 46.6605 46.9618 46.6605 44.3934C46.5987 38.6886 38.3711 29.6434 32.5227 29.6434Z",
    fill: "#E67500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.6802 28.7156C20.9164 26.1655 18.5498 24.5082 16.4049 25.0238C14.26 25.5394 13.143 28.0232 13.9072 30.5717C14.671 33.1276 17.0376 34.7849 19.1825 34.2693C21.3274 33.7537 22.4389 31.2641 21.6802 28.7156ZM27.919 27.1835C30.1929 26.585 31.3346 23.5669 30.4602 20.3061C29.5859 17.0452 27.0352 15.069 24.7525 15.6015C22.4787 16.2 21.337 19.2181 22.2113 22.479C23.0871 25.6735 25.6357 27.7875 27.919 27.1835ZM48.6463 25.0253C46.5014 24.576 44.1348 26.167 43.371 28.717C42.6071 31.2678 43.7208 33.753 45.8657 34.2686C48.0106 34.7179 50.3677 33.1269 51.1411 30.5769C51.902 28.0232 50.7235 25.5409 48.6463 25.0253ZM37.1263 27.1835C39.3434 27.7819 41.9597 25.6735 42.834 22.479C43.7083 19.2844 42.567 16.1996 40.2928 15.6015C38.0757 15.0031 35.4594 17.1115 34.5851 20.3061C33.7085 23.5006 34.8502 26.5868 37.1263 27.1835Z",
    fill: "#E67500"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPawSecondary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paw-secondary.d2ec5bd2.svg";
export { ForwardRef as ReactComponent };